export default __webpack_public_path__ + "static/media/Logo.9d9a8d08.svg";